import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.1106 9.7241C18.9199 9.01269 19.3663 8.23952 20.0777 8.0489L19.2608 5L3 9.35707L3.81695 12.406C4.52836 12.2153 5.30152 12.6617 5.49214 13.3731C5.68276 14.0846 5.23638 14.8577 4.52497 15.0483L5.34192 18.0972L21.6027 13.7402L20.7858 10.6913C20.0744 10.8819 19.3012 10.4355 19.1106 9.7241Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5356 9.39083L16.9749 14.7623"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.84924 11.4504L11.9786 10.3439"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.6593 13.8158L10.7152 13.2649"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5641 14.1557C20.5641 14.8922 21.1954 15.5235 21.9319 15.5235V18.0972H5.3656"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'buyticket');
export default IconComponent;
